import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Prefecturelist } from "../values/value";
import { DateModal } from "./modal";
import { set_movingDate } from "../store/movingDate";

import {
  ScheduleComponent,
  Month,
  Inject,
  ViewsDirective,
  ViewDirective
} from "@syncfusion/ej2-react-schedule";
import { loadCldr, L10n, registerLicense } from "@syncfusion/ej2-base";

import * as numberingSystems from "../culture-files/numberingSystems.json";
import * as gregorian from "../culture-files/ca-gregorian.json";
import * as numbers from "../culture-files/numbers.json";
import * as timeZoneNames from "../culture-files/timeZoneNames.json";

import Header from "./header";
import { AlertDialogSlide } from "./notificationModal";
// import axios from "axios";
// import { useEffect } from "react";
// import { CONTRACT_ENDPOINT } from "../endpoint";

  registerLicense("Ngo9BigBOggjHTQxAR8/V1NMaF1cXmhKYVFwWmFZfVtgc19CZ1ZUQWYuP1ZhSXxWdkdhXX9ZdHNQQWZUV00=");
  const MovingDate = () => {
  const [openModal, setOpenModal] = useState(false);
  const [notificationModal, setNotificationModal] = useState(false);
  const dispatch = useDispatch();
  const { movingDate } = useSelector(state => state);
  const furniture = useSelector(state => state.furniture)
  const address = useSelector(state => state.address);
  const [selectedHours, setSelectedHours] = useState([]);

  const currentPrefecture = Prefecturelist.find((item) => (item.name === address.currentPrefecture))
  const newPrefecture = Prefecturelist.find((item) => (item.name === address.newPrefecture));

  const handleCellClick = (selectedDate) => {

    const [year, month, date] = selectedDate.split("-");
    const nowDate = new Date().toISOString().slice(0, 10);
    if (selectedDate > nowDate)
      setOpenModal(true);
    else setNotificationModal(true);
    const newDate = {
      ...movingDate,
      year,
      month,
      date,
    };

    dispatch(set_movingDate(newDate));
  }

  const data = [
    {
      Id: 1,
      Subject: 'Meeting',
      StartTime: new Date(2023, 2, 15, 10, 0),
      EndTime: new Date(2023, 2, 15, 12, 30),
    },
  ];
  const scheduleObj = React.useRef(null);
  loadCldr(numberingSystems, gregorian, numbers, timeZoneNames);
  const onCellClick = (args) => {
    args.cancel = true;
    const selectedDate = args.startTime;
    
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth() + 1; // Adding 1 since getMonth() returns 0-11
    const date = selectedDate.getDate();
    
    const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${date.toString().padStart(2, '0')}`;
    
    handleCellClick(formattedDate);
  };

  const onCellDoubleClick = (args) => {
    args.cancel = true;
  }

  L10n.load({
    es: {
      schedule: {
        day: "日",
        week: "Semana",
        workWeek: "Semana de trabajo",
        month: "Mes",
        agenda: "Agenda",
        weekAgenda: "Agenda de la semana",
        workWeekAgenda: "Agenda de la semana laboral",
        monthAgenda: "Agenda del mes",
        today: "今日",
        noEvents: "No hay eventos",
        emptyContainer: "No hay eventos programados para este día.",
        allDay: "Todo el dia",
        start: "comienzo",
        end: "Final",
        more: "más",
        close: "Cerca",
        cancel: "Cancelar",
        noTitle: "(Sin título)",
        delete: "Eliminar",
        deleteEvent: "Este evento",
        deleteMultipleEvent: "Eliminar múltiples eventos",
        selectedItems: "Artículos seleccionados",
        deleteSeries: "Serie completa",
        edit: "Editar",
        editSeries: "Serie completa",
        editEvent: "Este evento",
        createEvent: "Crear",
        subject: "Tema",
        addTitle: "Añadir título",
        moreDetails: "Más detalles",
        save: "Salvar",
        editContent: "¿Cómo le gustaría cambiar la cita en la serie?",
        deleteContent: "¿Seguro que quieres eliminar este evento?",
        deleteMultipleContent:
          "¿Estás seguro de que deseas eliminar los eventos seleccionados?",
        newEvent: "Nuevo evento",
        title: "Título",
        location: "Ubicación",
        description: "Descripción",
        timezone: "Zona horaria",
        startTimezone: "Zona horaria de inicio",
        endTimezone: "Zona horaria final",
        repeat: "Repetir",
        saveButton: "Salvar",
        cancelButton: "Cancelar",
        deleteButton: "Eliminar",
        recurrence: "Reaparición",
        wrongPattern: "El patrón de recurrencia no es válido.",
        seriesChangeAlert:
          "¿Desea cancelar los cambios realizados en instancias específicas de esta serie y volver a vincularlos con toda la serie?",
        createError:
          "La duración del evento debe ser más corta que la frecuencia con la que ocurre. Acorte la duración o cambie el patrón de recurrencia en el editor de eventos de recurrencia.",
        sameDayAlert:
          "Dos ocurrencias del mismo evento no pueden ocurrir en el mismo día.",
        editRecurrence: "Editar recurrencia",
        repeats: "Repite",
        alert: "Alerta",
        startEndError:
          "La fecha de finalización seleccionada ocurre antes de la fecha de inicio.",
        invalidDateError: "El valor de la fecha ingresada no es válido.",
        blockAlert:
          "Los eventos no se pueden programar dentro del rango de tiempo bloqueado.",
        ok: "Okay",
        yes: "si",
        no: "No",
        occurrence: "Ocurrencia",
        series: "Serie",
        previous: "Anterior",
        next: "próximo",
        timelineDay: "Día de la línea de tiempo",
        timelineWeek: "Semana de la línea de tiempo",
        timelineWorkWeek: "Semana laboral cronológica",
        timelineMonth: "Mes de la línea de tiempo",
        timelineYear: "Cronología Año",
        editFollowingEvent: "Eventos siguientes",
        deleteTitle: "Eliminar evento",
        editTitle: "Editar evento",
        beginFrom: "Comience desde",
        endAt: "Termina en"
      },
      recurrenceeditor: {
        none: "Ninguna",
        daily: "Diario",
        weekly: "Semanal",
        monthly: "Mensual",
        month: "Mes",
        yearly: "Anual",
        never: "Nunca",
        until: "Hasta",
        count: "Contar",
        first: "primero",
        second: "Segundo",
        third: "Tercero",
        fourth: "Cuarto",
        last: "Último",
        repeat: "Repetir",
        repeatEvery: "Repite cada",
        on: "Repetir en",
        end: "Final",
        onDay: "Día",
        days: "Dias)",
        weeks: "Semanas)",
        months: "Meses)",
        years: "Años)",
        every: "cada",
        summaryTimes: "veces)",
        summaryOn: "en",
        summaryUntil: "hasta",
        summaryRepeat: "Repite",
        summaryDay: "dias)",
        summaryWeek: "semanas)",
        summaryMonth: "meses)",
        summaryYear: "años)",
        monthWeek: "Mes Semana",
        monthPosition: "Posición del mes",
        monthExpander: "Expansor de mes",
        yearExpander: "Expansor de año",
        repeatInterval: "Intervalo de repetición"
      },
      calendar: {
        today: "今日"
      }
    }
  });

  return (
    <section>
      <Header />
      <div className="percent-bar">
        <div className="percent">
          <label>家財メーター</label>
          <input type="range" min={"0"} max={"100"} value={furniture.percentData1} step={"10"} readOnly />
          <div className="number">{furniture.percentData1}%</div>
        </div>
        <div className="percent">
          <label>家財メーター</label>
          <input type="range" min={"0"} max={"100"} value={furniture.percentData2} step={"10"} readOnly />
          <div className="number">{furniture.percentData2}%</div>
        </div>
        {furniture.percentData2 === 100 && (
          <div className="visit-price">2トン以上のお荷物は訪問見積もりになります</div>
        )}
      </div>
      <div className="current-new-address">
        <div className="current">
          <p className="current-label">現住所</p>
          <div className="current-address-confir">{currentPrefecture.name + address.currentCity}</div>
        </div>
        <div className="movement-arrow">
          <img src="./image/arrow.png" alt="arrow" />
        </div>
        <div className="new">
          <p className="new-label">転居先</p>
          <div className="new-address-confir">{newPrefecture.name + address.newCity}</div>
        </div>
      </div>
      <div className="step1"><img src="./image/step2.png" alt="step2" /></div>
      <div className='demo-app'>
        <div className='demo-app-main'>
          <ScheduleComponent
            width="100%"
            height="650px"
            selectedDate={new Date()}
            ref={scheduleObj}
            eventSettings={{ dataSource: data }}
            // locale="es"
            cellClick={onCellClick}
            cellDoubleClick={onCellDoubleClick}
          >
            <ViewsDirective>
              <ViewDirective option='Month' />
            </ViewsDirective>
            <Inject services={[Month]} />
          </ScheduleComponent>
        </div>
      </div>
      <div className="furniture-btn">
        <Link to={"/confirm"} className="btn-shape fur-btn-previous">戻る</Link>
      </div>
      <div>
        <DateModal
          open={openModal && selectedHours.length < 2}
          onClose={() => setOpenModal(false)}
          hours={selectedHours}
        />
      </div>
      <AlertDialogSlide
        show={notificationModal}
        handleClose={() => setNotificationModal(false)}
        message={"正確な日時を選択してください。"}
      />
    </section>
  )
}

export default MovingDate;


